<section
  id="login-back"
  class="inner-section"
>
  <img
    src="@/assets/images/logo.png"
    alt=""
    id="logo"
    class="energy2go-logo"
  />
  <div
    id="login-div"
    class="py-2 blue-background"
  >
    <div class="m-3">
      <h3
        class="navbar-text"
        v-text="$t('login.sign_in')"
      ></h3>

      <div class="error-container">
        <p
          v-if="error"
          class="errors"
        >
          <b>{{ error }}</b>
        </p>
      </div>

      <div class="validation-boxes">
        <div
          class="mb-0 gap"
          v-for="(_, index) in code"
          :key="index"
        >
          <input
            :id="'id_' + index"
            maxlength="VALIDATION_CODE_LENGTH"
            required
            v-model="code[index]"
            type="text"
            autocapitalize="none"
            @input="onInput(index, $event)"
            @keydown="onKeyDown(index, $event)"
            @focus="onFocus($event)"
            @click="onClick($event)"
            ref="inputs"
          />
        </div>
      </div>
      <h6 class="mb-3">{{ $t('login.verify_mail') }}</h6>

      <div class="centered-div mb-2">
        <BaseButton
          id="validate_button"
          variant="primary"
          unstyled
          block
          class="btn-lg"
          v-on:click="validateCode"
        >
          {{ $t('login.validate') }}
        </BaseButton>
      </div>

      <div class="m-auto width-250">
        <BaseButton
          variant="primary"
          unstyled
          block
          class="btn-lg"
          v-on:click="routeSignUp"
        >
          {{ $t('login.resend_email') }}
        </BaseButton>
      </div>
    </div>
  </div>

  <div
    class="mt-3 clearfix"
    id="account-options"
  >
    <router-link
      class="link"
      to="/login-social"
      v-text="$t('login.register_social')"
    ></router-link>
  </div>

  <a
    :href="$t('login.whatsapp_msg')"
    target="_blank"
  >
    <font-awesome-icon
      class="whatsapp-icon-fixed"
      :icon="{ prefix: 'fab', iconName: 'whatsapp' }"
      size="2x"
    />
  </a>
</section>
